var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3405_841)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3405_841",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3405_841",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3405_841",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAU9JREFUSA2tljtOBTEMRU9ByQIoKFgKi6FgOXQgwQ5gB7yORVBABxL0lBTAGSUoL/F8Mm8sjZLYzr2240QDcAf8rPyegBNmRPDjGZ8x8xXwPEciwSEyS3IogcFNkmxBkEk8k0a2IhA4xAqVTRjLFCFWqFyG13iFWKGy2bpM8Rm5bUkQ4ccHE3quVK7N4By4Bz5S9zi6Vr8nvQRHwC3wClz8vWWnCc3xMumvAf0G6SUQfDfxfvmuaZekm8D0jbx+HC1PKdr1G8rVk8FDKksJ5jzCsFz6h8YaIK+NNNc868YwzoC3MWO5uZxHkWr/Kjqp8R/bVDrmuTc1yiDby9EM3lX0EFhTa7tEVp2BXfESdFFNaBfp191FAvmT8DhBIrj2m8xqieq+zrZo9IZKYoSWwVorjq7VC/5/k3X+Tmch2dhXXybT90w8SPc4uh7Kkkj5BZLjZQnXGulMAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentClock);
export default __webpack_public_path__ + "static/media/document-clock.5882cf8974c2d24d265cc35e44493eaf.svg";
export { ForwardRef as ReactComponent };